<template>
  <b-button v-bind="$attrs" @click="onClick">
    <WaveSpinner v-if="busy" :color="spinnerColor" inline />
    <slot v-else />
  </b-button>
</template>

<script>
import notifyPromise from "@/lib/bubble/notifyPromise";
export default {
  props: {
    action: {type: String, required: true},
    arg: {default: null},
    success: {type: [String, Function], default: undefined},
    spinnerColor: {type: String, default: "white"}
  },
  data() {
    return {busy: false}
  },
  methods: {
    async onClick(evt) {
      this.busy = true;
      await notifyPromise(evt.path, this.$store.dispatch(this.action, this.arg), this.success);
      this.busy = false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/ActionButton.vue